import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState, useCallback } from 'react';
const defaultFlags = {
// No feature flags currently defined
};
const FeatureFlagsContext = createContext({
    flags: defaultFlags,
    setFlag: () => { },
});
export function FeatureFlagsProvider({ children, flags = {} }) {
    const [currentFlags, setCurrentFlags] = useState(() => ({
        ...defaultFlags,
        ...flags,
    }));
    const setFlag = useCallback((key, value) => {
        setCurrentFlags((prev) => ({ ...prev, [key]: value }));
    }, []);
    const contextValue = useMemo(() => ({
        flags: currentFlags,
        setFlag,
    }), [currentFlags, setFlag]);
    return _jsx(FeatureFlagsContext.Provider, { value: contextValue, children: children });
}
export function useFeatureFlags() {
    const { flags } = useContext(FeatureFlagsContext);
    return flags;
}
export function useFeatureFlagsWithSetter() {
    return useContext(FeatureFlagsContext);
}
export function useFeatureFlag(flag) {
    const flags = useFeatureFlags();
    return flags[flag];
}
